// @flow

import { createSelector } from 'reselect'

import { getUiSettings, isFeatureEnabled } from '@alphaott/smart-tv-config'
import { isEpgEnabled as getEnabledEpg } from '@alphaott/app-main/selectors'
import { getCustomerReviewMode } from '@alphaott/app-core/selectors'

export const getEnabledSmartTVEpg = createSelector(
  [getUiSettings, getEnabledEpg, getCustomerReviewMode],
  (uiSettings: Object, isEnabledEpg, customerReviewMode: boolean): boolean => {
    const isEnabledSmartTVEpg = isFeatureEnabled(uiSettings, 'epg')

    return isEnabledEpg && isEnabledSmartTVEpg && !customerReviewMode
  },
)
